import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ChoiceInputItem} from '../../../models/form-elements.model';
import {ValidationService} from '../../../services/validation.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-form-control-radio',
  templateUrl: './form-control-radio.component.html',
  styleUrls: ['./form-control-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormControlRadioComponent),
      multi: true
    }
  ]
})
export class FormControlRadioComponent implements OnInit, OnChanges, ControlValueAccessor {

  // Required
  @Input() label: string;
  @Input() name: string;
  @Input() id: string;
  @Input() choices: ChoiceInputItem[];

  // Conditional / Optional
  @Input() formSubmitted?: boolean;
  @Input() helpLink: string;
  @Input() cols?: number;

  // Default
  @Input() showLabel = true;
  @Input() showErrors = true;
  @Input() showOptional = true;
  @Input() isRequired = false;
  @Input() theme = 'light';
  @Input() style: 'default' | 'bordered' = 'bordered';

  @Output() selectedItem = new EventEmitter<any>();
  @Output() onHelpClick = new EventEmitter<any>();

  public valueSrc: string;
  hasError: 'null' | 'length' | '';

  set value(val: any) {
    if (val !== null && this.valueSrc !== val) {
      this.valueSrc = val;
      this.selectedItem.emit(this.valueSrc);
      this.validate();
      this.onChange(val);
      this.onTouch();
    }
  }

  get value(): any {
    return this.valueSrc;
  }

  constructor() {
  }


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.formSubmitted) {
      if (changes.formSubmitted.currentValue === true) {
        this.validate();
      }
    }
    if (changes && changes.isRequired) {
      this.validate();
    }
  }

  writeValue(value: string) {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: (value: string) => void) {
    // Required by the ControlValueAccessor interface. Informs Angular of value changes
    // Save the function as a property to call later.
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    // Required by the ControlValueAccessor interface. Informs Angular when input is touched.
    // Save the function as a property to call later.
    this.onTouch = fn;
  }

  onChange(value?: string) {
  }

  onTouch() {
  }

  validate() {
    if (this.isRequired) {
      this.hasError = ValidationService.singleChoiceControlHasError(this.valueSrc, this.formSubmitted) ? 'null' : '';
    } else {
      this.hasError = '';
    }
  }

}
